import React from 'react';
import {
  Box,
  HeadingText,
  Modal,
  styled,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';

const DEFAULT_HEADER_HEIGHT = '50px';

const modalTitleId = 'iframe-modal-title';

type IframeModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  title?: string;
  headerHeight?: string;
  showCloseButton?: boolean;
};

const ContentWrapper = styled(Box, {
  height: 'calc(100vh - 96px)',
  overflow: 'hidden',
  position: 'relative',
  width: '95vw',
  borderRadius: '$none',
  '@mobile': {
    width: '100%',
  },
});

const HeaderBlock = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$surface.background.primary',
  borderBottom: '1px solid $border.subtle',
});

const ModalBody = styled(Box, {
  width: '100%',
  backgroundColor: '$surface.background.primary',
});

export const IframeModal = ({
  open,
  onOpenChange,
  children,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  title,
  showCloseButton = true,
}: IframeModalProps) => (
  <Modal.Root open={open} onOpenChange={onOpenChange}>
    <Modal.Content
      showCloseButton={showCloseButton}
      width="auto"
      css={{
        '.GDS-modal': { zIndex: 'calc($modal - 1)', borderRadius: '$none' },
        '.GDS-modal-overlay': { zIndex: 'calc($modal - 1)' },
        '.GDS-modal-close-button-wrapper': { padding: '$half' },
      }}
      padding="none"
    >
      <Modal.Title>
        <VisuallyHidden>{modalTitleId}</VisuallyHidden>
      </Modal.Title>
      <ContentWrapper>
        {/* Header Block - only show if title exists */}
        {title && (
          <HeaderBlock css={{ height: headerHeight }}>
            <HeadingText size="lg" level="1">
              {title}
            </HeadingText>
          </HeaderBlock>
        )}
        {/* Modal Body */}
        <ModalBody
          css={{ height: title ? `calc(100% - ${headerHeight})` : '100%' }}
          tabIndex={0}
        >
          {children}
        </ModalBody>
      </ContentWrapper>
    </Modal.Content>
  </Modal.Root>
);
